export default __webpack_public_path__ + "static/media/logo-blue-desc.3f343b00.png";